import React from 'react';

const NotificationContext = React.createContext({
  notifications: [],
  unreadCount: 0
});

export default NotificationContext;
